import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackDeselectedItems } from "@air/analytics";
import { resetSelectedItemsAction, selectedItemsSelector } from "@air/redux-selected-items";
import { Router } from "next/router";
import { memo, useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GalleryItemType } from "~/components/Gallery/types";
import { SelectionActionBar } from "~/components/SelectionActionBar/index";
import { selectedBoardsSelector, selectedFileClipsSelector, selectedMediaClipsSelector } from "~/store/selectedItems/selectors";
import { getClipIdFromPath } from "~/utils/PathUtils";
const _BoardsAndAssetsSelectionBar = (param)=>{
    let { getAssetMenuOptions, getBoardMenuOptions, getFileMenuOptions, getSelectionMenuOptions, quickActionsIds } = param;
    const dispatch = useDispatch();
    const { trackDeselectedItems } = useTrackDeselectedItems();
    const options = getSelectionMenuOptions("action-bar", true);
    const selectedItems = useSelector(selectedItemsSelector);
    const selectedBoardItems = useSelector(selectedBoardsSelector);
    const selectedMediaClipItems = useSelector(selectedMediaClipsSelector);
    const selectedFileItems = useSelector(selectedFileClipsSelector);
    const selectedItemsCount = selectedItems.length;
    useEffect(()=>{
        const routeChangeStartHandler = (url)=>{
            if (selectedItemsCount && !getClipIdFromPath(url)) {
                dispatch(resetSelectedItemsAction());
            }
        };
        Router.events.on("routeChangeStart", routeChangeStartHandler);
        return ()=>{
            Router.events.off("routeChangeStart", routeChangeStartHandler);
        };
    }, [
        dispatch,
        selectedItemsCount
    ]);
    const onClearAll = useCallback(()=>{
        trackDeselectedItems({
            fileSelectionCount: 0,
            assetSelectionCount: 0,
            boardSelectionCount: 0,
            totalSelectionCount: 0,
            trigger: "action-bar",
            type: "none"
        });
        dispatch(resetSelectedItemsAction());
    }, [
        dispatch,
        trackDeselectedItems
    ]);
    const { menuOptions } = useMemo(()=>{
        let menuOptions = options;
        if (selectedItems.length === 1) {
            if (selectedItems[0].type === GalleryItemType.board) {
                const board = selectedBoardItems[0];
                menuOptions = getBoardMenuOptions({
                    item: board
                })({
                    trackLocation: "action-bar"
                });
            } else if (selectedItems[0].type === GalleryItemType.asset) {
                const clip = selectedMediaClipItems[0];
                menuOptions = getAssetMenuOptions({
                    item: clip
                })({
                    trackLocation: "action-bar"
                });
            } else if (selectedItems[0].type === GalleryItemType.file) {
                const file = selectedFileItems[0];
                menuOptions = getFileMenuOptions({
                    item: file
                })({
                    trackLocation: "action-bar"
                });
            }
        }
        return {
            menuOptions
        };
    }, [
        getAssetMenuOptions,
        getBoardMenuOptions,
        getFileMenuOptions,
        options,
        selectedBoardItems,
        selectedMediaClipItems,
        selectedFileItems,
        selectedItems
    ]);
    return /*#__PURE__*/ _jsx(SelectionActionBar, {
        onClearAll: onClearAll,
        quickActionsIds: quickActionsIds,
        options: menuOptions,
        selectedItemsCount: selectedItems.length
    });
};
_BoardsAndAssetsSelectionBar.displayName = "BoardsAndAssetsSelectionBar";
const _BoardsAndAssetsSelectionBarMemo = /*#__PURE__*/ memo(_BoardsAndAssetsSelectionBar);
export const BoardsAndAssetsSelectionBar = _BoardsAndAssetsSelectionBarMemo;
